import { Component, Output, Input } from 'angular-ts-decorators';
import { SwChange } from '@core/app/scripts/classes/sw-change';

import { remove, each, set } from 'lodash';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { Country } from '@core/app/scripts/services/country';
import { Account, AccountAddressModel } from '../../services/account';

/**
 * The address list component displays a list of mailing and/or
 * physical postal addresses.
 *
 * # Example
 * <pre>
 *   <sw-address-list list="$ctrl.list", sw-change="$ctrl.onChange()"></sw-address-list>
 * </pre>
 */
@Component({
  selector: 'swAddressList',
  template: require('./sw-address-list.html').default,
})
export class SwAddressListComponent extends SwChange {
  @Input() list: AccountAddressModel[];
  @Output() swChange: () => any;
  countryList: any;
  faCheck = faCheck;

  constructor(
    private country: Country,
    private account: Account,
  ) {
    'ngInject';
    super();

    this.countryList = country.getCountryInfoList();
  }

  setPrimary(address, $event) {
    $event.stopPropagation();

    each(this.list, (element) => set(element, 'primary', false));
    address.primary = true;

    this.change(this.list);
  }

  addItem() {
    if (!angular.isArray(this.list)) {
      this.list = [];
    }

    this.list.push(this.account.getAddressModel());

    this.change(this.list);
  }

  removeItem(address) {
    remove(this.list, address);

    this.change(this.list);
  }
}
